import styled from '@emotion/styled';
import { postApi } from '@api/PostInfoApi';
import { commentApi } from '@api/CommentApi';
import { postListApi } from '@api/PostApi';
import { useEffect, useState } from 'react';
import { COLOR_BORDER } from '@assets/color';
import { useUserContext } from '@contexts/UserContext/UserProvider';
import { Image } from '@atomic';
import {
  PostContent,
  UserInfo,
  PostCommentInput,
  PostCommentList,
  PostList,
} from '@domain';

const DetailWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const PostContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  width: 65%;
  border: 1px solid ${COLOR_BORDER};
  border-radius: 30px;
`;

const ContentBox = styled.div`
  padding: 20px;
  box-sizing: border-box;
`;

const MorePostContainer = styled.div`
  margin-top: 30px;
  font-size: 18px;
  font-weight: 700;
`;

const Detail = (props) => {
  const { id } = props.match.params;
  const [postInfo, setPostInfo] = useState(null);
  const { currentUser } = useUserContext();
  const { fullName, coverImage } = currentUser;
  const [morePostList, setMorePostList] = useState(null);

  useEffect(async () => {
    try {
      const postData = await postApi(id);
      const postListData = await postListApi({
        offset: 10,
        limit: 10,
      });

      setPostInfo(postData.data);
      setMorePostList(postListData.data);
    } catch (e) {
      alert(e);
    }
  }, [id]);

  const handleComment = async (e) => {
    if (e.key === 'Enter') {
      const { value } = e.target;

      await commentApi({
        comment: value,
        postId: id,
      });

      setPostInfo({
        ...postInfo,
        comments: [
          ...postInfo.comments,
          {
            _id: Math.random(),
            comment: value,
            author: {
              fullName,
              image: coverImage,
            },
            createdAt: new Date(),
          },
        ],
      });

      e.target.value = '';
    }
  };

  return (
    <DetailWrapper>
      {postInfo && (
        <PostContainer>
          <Image
            src={postInfo.image || ''}
            width="100%"
            height="100%"
            mode="cover"
            style={{
              borderTopLeftRadius: '30px',
              borderBottomLeftRadius: '30px',
              boxSizing: 'border-box',
            }}
          />
          <ContentBox>
            <UserInfo user={postInfo.author} />
            <PostContent content={postInfo.title} maxLength={10} />
            <PostCommentList comments={postInfo.comments} />
            <PostCommentInput
              image={postInfo.author.image}
              onKeyUp={handleComment}
            />
          </ContentBox>
        </PostContainer>
      )}
      <MorePostContainer>
        {morePostList && (
          <PostList postList={morePostList} listTitle="다른 포스트 더보기" />
        )}
      </MorePostContainer>
    </DetailWrapper>
  );
};

export default Detail;
